import React from 'react'
import {useHistory} from 'react-router-dom'

export default () => {
    const history = useHistory()
    return(
        <nav className="navbar navbar-light bg-dark">
            <div onClick={()=>history.push('/')} className="navbar-brand text-white">
                <img src="https://cdn6.aptoide.com/imgs/4/c/3/4c3c0865d1b381892714c27a121c4fe5_icon.png?w=256" width="30" height="30" className="d-inline-block align-top" alt=""/>
                Hogwarts
            </div>
            <button onClick={()=>history.push('/spells')} className="btn btn-dark">Spells</button>
            <button onClick={()=>history.push('/spells/fav')} className="btn btn-dark">Fav Spells</button>
        </nav>
    )
}